// @flow
import React, { Fragment } from "react";
import { withGlobalContext } from "../../../common/GlobalContext";

import type { $Site } from "flow/types";

import TransparentCircles from "./TransparentCircles";
import PhotoBox from "./PhotoBox";
import Box from "./Box";
import { PROVIDERS_OUTSIDE_US } from "../../../../../../lib/constant.js";

type $Props = {
  site: $Site,
  CDN_IMAGE_SERVER_URL: string,
};

const FeaturedResources = ({ site, CDN_IMAGE_SERVER_URL }: $Props) => {
  const { pods } = site.uiConfig;
  const hideMortgageCalc =
    site &&
    site.datastoreProviderIds.every((dpi) =>
      PROVIDERS_OUTSIDE_US.includes(dpi)
    );

  return (
    <Fragment>
      {pods.map((pod) => {
        if (pod.value === "transparentCircleResources") {
          const backgroundImage = `${CDN_IMAGE_SERVER_URL}/hero-images/kitchen/Kitchen24.jpg?w=1080&or=0`;
          return (
            <TransparentCircles
              key={pod.value}
              backgroundImage={backgroundImage}
              hideMortgageCalc={hideMortgageCalc}
            />
          );
        } else if (pod.value === "originalBoxShapedResources") {
          return <Box key={pod.value} hideMortgageCalc={hideMortgageCalc} />;
        } else if (pod.value === "backgroundPhotoBoxShapedResources") {
          return (
            <PhotoBox key={pod.value} hideMortgageCalc={hideMortgageCalc} />
          );
        } else {
          return null;
        }
      })}
    </Fragment>
  );
};

export default withGlobalContext(FeaturedResources);
